export default __webpack_public_path__ + "static/media/Wendy-Dorr.3badae63.jpg";